export default __webpack_public_path__ + "static/media/updatePhoto-rejected.b81d34e6.svg";